import React from 'react';

const SuffererCard = ({ icon, gradientClass, title, value }) => {
    return (
        <div className='flex flex-grow xl:w-48 p-5 items-center rounded-lg bg-white space-x-5'>
            <div className={`flex h-10 w-10 items-center justify-center rounded-full ${gradientClass}`}>
                {icon}
            </div>
            <div className='flex flex-col flex-grow text-xs md:text-sm'>
                <h2 className='font-medium'>{title}</h2>
                <p className='font-semibold'>{value}</p>
            </div>
        </div>
    );
};

export default SuffererCard;
